module.exports = {
  "wrapper": {
    "width": "750",
    "height": "724",
    "alignItems": "center"
  },
  "png-wrapper": {
    "position": "absolute"
  },
  "custorm-animate-wrapper": {
    "position": "absolute",
    "width": "750",
    "height": "600"
  },
  "lottie": {
    "position": "absolute",
    "width": "750",
    "height": "600"
  },
  "png": {
    "width": "600",
    "height": "600"
  },
  "digital-wrapper": {
    "width": "750",
    "height": "600",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "digital": {
    "width": "750",
    "alignItems": "center"
  },
  "top-title-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "24",
    "color": "#616C73",
    "letterSpacing": 0,
    "textAlign": "center",
    "lineHeight": "24"
  },
  "main-title": {
    "flexDirection": "row",
    "paddingTop": "18",
    "paddingRight": "18",
    "paddingBottom": "18",
    "paddingLeft": "18"
  },
  "main-title-value": {
    "paddingTop": 0,
    "paddingRight": "50",
    "paddingBottom": 0,
    "paddingLeft": "50"
  },
  "main-title-value-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "160",
    "color": "#1E2E37",
    "letterSpacing": 0,
    "textAlign": "center",
    "lineHeight": "162"
  },
  "main-text-size-offline": {
    "fontSize": "80"
  },
  "main-title-unit": {
    "position": "absolute",
    "right": "20",
    "top": "20"
  },
  "main-title-unit-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "40",
    "color": "#1E2E37",
    "letterSpacing": 0,
    "textAlign": "center",
    "lineHeight": "40"
  },
  "desc-wrapper": {
    "width": "600",
    "flexDirection": "row"
  },
  "desc": {
    "flex": 1,
    "alignItems": "flex-start",
    "justifyContent": "center"
  },
  "desc-align-center": {
    "alignItems": "center"
  },
  "desc-align-end": {
    "alignItems": "flex-end"
  },
  "desc-title": {
    "marginBottom": "20"
  },
  "desc-title-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "24",
    "color": "#8E969B",
    "letterSpacing": 0,
    "lineHeight": "24",
    "paddingTop": 0,
    "paddingRight": "32",
    "paddingBottom": 0,
    "paddingLeft": "32"
  },
  "desc-value-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32",
    "color": "#616C73",
    "letterSpacing": "0",
    "lineHeight": "32",
    "paddingTop": 0,
    "paddingRight": "32",
    "paddingBottom": 0,
    "paddingLeft": "32"
  },
  "desc-item-split-line": {
    "width": "1",
    "height": "60",
    "backgroundColor": "#e5e5e8",
    "position": "absolute",
    "right": "0"
  },
  "status-bar-wrapper": {
    "width": "600",
    "height": "140",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "-50"
  },
  "second-lottie": {
    "position": "absolute",
    "left": "300",
    "top": "70",
    "transform": "translate(-50%, -50%)"
  },
  "status-bar": {
    "minWidth": "224",
    "height": "60"
  },
  "status-bar-title": {
    "height": "60",
    "borderRadius": "30",
    "justifyContent": "center",
    "backgroundColor": "#7c870b",
    "paddingTop": 0,
    "paddingRight": "32",
    "paddingBottom": 0,
    "paddingLeft": "32"
  },
  "status-bar-title-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "32",
    "color": "#ffffff",
    "letterSpacing": 0,
    "textAlign": "center",
    "lineHeight": "32"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-23dbdeac!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-digital-panel/index.vue
// module id = 451
// module chunks = 0 1